import { FC, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { ActionMenu, Button } from '@servicetitan/design-system';

import { ApiGroup } from '../../api/app.api';

export interface ResourceOwnerMenuProps {
    selectedApiGroup: ApiGroup;
    selectedResourceOwner: string;
    assignedResourceOwners: string[];
}

export const ResourceOwnerMenu: FC<ResourceOwnerMenuProps> = ({
    selectedApiGroup,
    selectedResourceOwner,
    assignedResourceOwners,
}) => {
    const history = useHistory();
    const [menuOpen, setMenuOpen] = useState(false);

    const handleToggleMenu = useCallback(() => {
        setMenuOpen(!menuOpen);
    }, [menuOpen]);

    const handleCloseMenu = useCallback(() => {
        setMenuOpen(false);
    }, []);

    return (
        <ActionMenu
            trigger={
                <Button
                    fill="subtle"
                    iconName="expand_more"
                    aria-label={`Switch ${selectedApiGroup.resourceOwnerTerm}`}
                    onClick={handleToggleMenu}
                />
            }
            direction="bl"
            sharp
            width="xs"
            portal={false}
            open={menuOpen}
            onClickOutside={handleCloseMenu}
        >
            {assignedResourceOwners
                .filter(owner => owner !== selectedResourceOwner)
                .map(owner => (
                    <ActionMenu.Item
                        key={owner}
                        onClick={() => {
                            history.push(`/clients/${selectedApiGroup.name}/${owner}`);
                        }}
                    >
                        {owner}
                    </ActionMenu.Item>
                ))}
        </ActionMenu>
    );
};
ResourceOwnerMenu.displayName = 'ResourceOwnerMenu';
